import { render, staticRenderFns } from "./D2BZMD3010.vue?vue&type=template&id=13f738fa&scoped=true&"
import script from "./D2BZMD3010.js?vue&type=script&lang=js&"
export * from "./D2BZMD3010.js?vue&type=script&lang=js&"
import style0 from "./D2BZMD3010.vue?vue&type=style&index=0&id=13f738fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f738fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VRadioGroup,VRow})
